import { render, staticRenderFns } from "./PerformanceCustomersList.vue?vue&type=template&id=0f005022&scoped=true&"
import script from "./PerformanceCustomersList.vue?vue&type=script&lang=ts&"
export * from "./PerformanceCustomersList.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceCustomersList.vue?vue&type=style&index=0&id=0f005022&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f005022",
  null
  
)

export default component.exports